import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import { InputText, Dropdown as Select, Calendar, confirmDialog, InputTextarea, Toast } from "../../PrimeReactComponents";
import { Button, Modal } from "../../BootstrapComponents";
import { Formik, Form, FieldArray, Field, ErrorMessage } from 'formik';
import { getCountry, getState } from '../../services/commonController';
import { customerInitialState, customerValidateSchema } from '../Validations/CustomersEditValidation';
import { singleData, uploadDocument, uploadCustomerDocument, deletCustomerImage, updateData, removeCompanyDocument, removeCompanyNote, removeCompanyBilling } from '../controllers/customerController';

import Loader from "../../features/loader/Loader";
import { REACT_APP_MAX_FILE_SIZE_UPLOAD, REACT_APP_BASE_BACKEND_URL } from '../../config'
let BASE_BACKEND_URL = REACT_APP_BASE_BACKEND_URL;
let maxSize = REACT_APP_MAX_FILE_SIZE_UPLOAD;

function Edit() {
  const { transportUserInfo } = useSelector(state => state);
  let company_id = transportUserInfo.company_id
  const navigate = useNavigate();
  const toast = useRef(null);
  const [loader, setLoader] = useState();

  const [country, setCountry] = useState();
  const [states, setStates] = useState();
  const [initialState, setInitialState] = useState(customerInitialState);
  const [modalShow, setModalShow] = React.useState(false);
  const [selectedFile, setSelectedFile] = useState();


  const pathname = window.location.pathname


  let customerArr = []
  let transportPermission = JSON.parse(localStorage.getItem('rolePermissionTransportInfo'))

  transportPermission.length > 0 && transportPermission.filter(e => e.menuData?.menu_name === 'Customers')?.map(val => {
    if (!customerArr.includes(val?.menuActionData?.action_name)) {
      customerArr.push(val?.menuActionData?.action_name)
    }
  })

  if (pathname.split('/')[3] === 'edit') {
    if (!customerArr.includes('Edit')) {
      navigate('/transport/404');
    }
  }

  let allFilesArr = []
  const { id } = useParams();

  const getAllCountries = async () => {
    const results = await getCountry();
    setCountry(results.data)
  }

  const getAllStates = async () => {
    const results = await getState();
    setStates(results.data)
  }

  const getSingleData = async () => {
    setLoader(true)
    const list = await singleData(id);
    if (list) {
      let customerData = list.data?.data
      // Ensure at least one billing address row exists
      if (
        !customerData.customer_billing_address_details ||
        customerData.customer_billing_address_details.length === 0
      ) {
        customerData.customer_billing_address_details = [
          customerInitialState.customer_billing_address_details[0]
        ];
      }
      setInitialState(customerData);

      // let total_customer_document = customerData?.customer_document_details.length
      // allFilesArr =  new Array(total_customer_document).fill(0);
      //console.log("this is log.....",initialState);

      setLoader(false)
    } else {
      setLoader(false)
    }
  }

  useEffect(() => {
    getAllCountries()
    getAllStates()
    getSingleData()
  }, [])

  useEffect(() => {
    getSingleData()
  }, [id])


  const customerSubmit = (formdata, id) => {
    let newCustomerDocumentArr = formdata.customer_document_details.map(id => id.customer_document_id)
    let newCustomerDocumentArrys = newCustomerDocumentArr !== null ? newCustomerDocumentArr : ""
    let newCustomerDocumentNameArr = formdata.customer_document_details.map(id => id.document_name)

    // const all_values = { ...formdata, customer_document_details: { driver_doc: allFilesArr }, customer_document_id: newCustomerDocumentArrys }
    const all_values = { ...formdata, customer_document_id: newCustomerDocumentArrys }

    updateData(all_values, id).then(({ type, message }) => {
      toast?.current?.show({ severity: type, summary: 'Info Message', detail: message, life: 3000, });
      setLoader(false)
      setTimeout(() => {
        navigate('/transport/customers')
      }, 3000)

    })
    setLoader(false)
  }

  const handleOnChange = async (event, index) => {
    if (event.target.files[0].name !== null) {
      let image_name = event.target.files[0]


      if (image_name && (image_name.type === 'image/jpg' || image_name.type === 'image/jpeg' || image_name.type === 'image/png' || image_name.type === 'application/pdf')) {
        if (image_name !== undefined) {
          const formData = new FormData();
          formData.append(`driver_doc`, image_name)

          const headers = {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          };

          const res = await uploadDocument(formData, headers)
          // allFilesArr.push(res.data)   
          allFilesArr.push({ [index]: res.data });
        }
      } else {
        toast.current.show({ severity: 'error', summary: 'Info Message', detail: 'Please select a valid JPG, JPEG, PNG, PDF file Only.', life: 3000, });
      }

    }

  };

  const getCountryOption = () => {
    const option = [];
    country?.map((ele) => {
      option.push({ value: ele.id, label: ele.country_name })
    })
    return option;
  }

  const getStateOption = (CoutryId) => {
    const option = [];
    states?.filter((ele) => {
      if (ele.country_id == CoutryId) {
        option.push({ value: ele.id, label: ele.state_name })
      }
    })
    return option;
  }


  let loadImage = function (val) {

    var image = new Image();
    var url_image = BASE_BACKEND_URL + val?.document_name;
    image.src = url_image;

    if (image.width == 0) {

      if (val?.document_name?.split('.')?.pop() === 'pdf') {
        return val?.document_name !== '' && (((val?.document_name?.split('.')?.pop() === 'pdf')) ? <a href={`${BASE_BACKEND_URL}${val?.document_name}`} target="_blank"><i class='fas fa-file-pdf' style={{'fontSize':'18px','color':'red'}}></i></a> : <a href={`${BASE_BACKEND_URL}${val?.document_name}`} target="_blank"> <img src={`${BASE_BACKEND_URL}${val?.document_name}`} width="100" /></a>)
      } else {
        return <img src={`${BASE_BACKEND_URL}` + 'default_image.jpg'} width="100" />;
      }

    } else {
      return val?.document_name !== '' && (((val?.document_name?.split('.')?.pop() === 'pdf')) ? <a href={`${BASE_BACKEND_URL}${val?.document_name}`} target="_blank"><i class='fas fa-file-pdf' style={{'fontSize':'18px','color':'red'}}></i></a> : <a href={`${BASE_BACKEND_URL}${val?.document_name}`} target="_blank"> <img src={`${BASE_BACKEND_URL}${val?.document_name}`} width="100" /></a>)
    }
  }


  function closeModal() {
    setModalShow(false);
  }

  function openModal(e) {
    setModalShow(true);
  }
  const saveFile = async (event) => {
    event.preventDefault();    
    if (selectedFile !== null) {
        if (selectedFile.size > maxSize) { 
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'File size exceeds maximum limit of 6 MB.',
                life: 3000,
            });
            return;
        }
        else
        {
           closeModal();
        }        
        //getSingleData();
        setLoader(true)
        const headers = {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        };
        const formData = new FormData();
        formData.append('customer_id', pathname.split('/')[4]);
        formData.append('document_name', selectedFile);
        const res = await uploadCustomerDocument(formData, headers);
        if (res.error !== null) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'File upload failed.',
                life: 3000,
            });
        }
        else
        {
            toast.current.show({ severity: 'success', summary: 'Info Message', detail: res.message, life: 3000, });
            closeModal();
        }
        closeModal();
        getSingleData();
        setLoader(false)
    }
};



  const uploadImageHandler = async (event) => {
    if (event.target.files[0].name !== null) {
      let image_name = event.target.files[0] 
      

      if (image_name && (image_name.type === 'image/jpg' || image_name.type === 'image/jpeg' || image_name.type === 'image/png' || image_name.type === 'application/pdf')) {
        if (image_name !== undefined) { 
           
          const formData = new FormData();
          formData.append(`document_name`, image_name) 

          setSelectedFile(image_name)
        }
      } else {
        toast.current.show({ severity: 'error', summary: 'Info Message', detail: 'Please select a valid JPG, JPEG, PNG, PDF file Only.', life: 3000, });
      }

    }

  };

  const removeImage = async (id) => { 
    confirmDialog({
      message: 'Are you sure you want to delete?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        deletCustomerImage({id:[id]}).then(res => {
          toast?.current?.show({ severity: 'success', detail: 'Deleted Successfully', life: 3000, });
           
          setLoader(false)
          getSingleData()
        })

      },
      reject: () => {
        console.log('Not delete')
      }
    });
  }

  //validationSchema={customerValidateSchema}
  return (
    <>
      <Loader show={loader} />
      <Toast ref={toast} position="top-center" />
      <Formik enableReinitialize initialValues={initialState} validationSchema={customerValidateSchema} onSubmit={(formdata) => {
        confirmDialog({
          message: 'Are you sure you want to update?',
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            customerSubmit(formdata, id)
            setLoader(true)
          }
        });
      }}>
        {
          ({ values, handleChange, setFieldValue }) => (
            <div className="page-wrapper-without-aisde">
              <div className="body-content-wrap overflow-auto flex-grow-1 p-sm-3 ps-sm-4">
                <div className="container d-flex flex-column h-100 ">
                  <Form className="d-flex flex-column overflow-auto" encType="multipart/form-data">

                    <div className="container d-flex flex-column h-100 ">
                      <div className="px-4 mt-3">
                        <div className="d-flex align-items-center flex-wrap">
                          <div className="d-flex justify-content-between justify-content-sm-start align-items-center flex-grow-1">
                            <h2 className="fz24 me-md-3 text-slate-800  me-md-2 fw500 mb-0">Edit  Customer</h2>
                          </div>
                          <div className="mt-3 mt-sm-0 align-items-center ms-sm-4 ms-md-auto mt-xl-0 d-flex justify-content-end flex-grow-1">
                            <Link to="../" className="btn-gradient btn fz14 me-3">
                              <i className="fa-regular fa-times"></i> Cancel
                            </Link>
                            <button type="submit" className="bg-green text-white btn fz14 ">
                              <i className="fa-regular fa-save"></i> Save
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="overflow-auto flex-grow-1 mt-5 px-4">
                        <div className="card p-4">
                          <div className="card-body">
                            <div className="row gx-5">
                              <input type="text" className="form-control px-3" hidden />
                              <div className="col-12 mb-3 justify-content-between d-flex">
                                <h4 className=" fw600 fz16 text-dark">Customer</h4>
                                <Link to={`../address-book/${id}/${company_id}`} className="btn text-dark btn-gradient shadow-none ms-3">
                                  <i className="fa-regular fa-map"></i> Address Book
                                </Link>
                              </div>
                              <div className="col-sm-6 mb-4">
                                <label htmlFor="" className="mb-2 d-block">Customer Number  <span className="text-danger">*</span></label>
                                <Field name="customer_number" render={({ field }) => (
                                  <>
                                    <InputText className="form-control px-3" {...field} readOnly disabled />
                                    <ErrorMessage name="customer_number" component="span" className="from-error-span" />
                                  </>
                                )} />

                              </div>
                              <div className="col-sm-6 mb-4">
                                <label htmlFor="" className="mb-2">Company Name  <span className="text-danger">*</span></label>
                                <Field name="customer_company_name" render={({ field }) => (
                                  <>
                                    <InputText className="form-control px-3" {...field} maxLength={30} />
                                    <ErrorMessage name="customer_company_name" component="span" className="from-error-span" />
                                  </>
                                )} />
                              </div>
                              <div className="col-sm-6 mb-4">
                                <label htmlFor="" className="mb-2">First Name  <span className="text-danger">*</span></label>
                                <Field name="first_name" render={({ field }) => (
                                  <>
                                    <InputText className="form-control px-3" {...field} maxLength={50} />
                                    <ErrorMessage name="first_name" component="span" className="from-error-span" />
                                  </>
                                )} />
                              </div>
                              <div className="col-sm-6 mb-4">
                                <label htmlFor="" className="mb-2">Last Name  <span className="text-danger">*</span></label>
                                <Field name="last_name" render={({ field }) => (
                                  <>
                                    <InputText className="form-control px-3" {...field} maxLength={50} />
                                    <ErrorMessage name="last_name" component="span" className="from-error-span" />
                                  </>
                                )} />
                              </div>
                              <div className="col-sm-6 mb-4">
                                <label htmlFor="" className="mb-2">Email Address  <span className="text-danger">*</span></label>
                                <Field name="email_id" render={({ field }) => (
                                  <>
                                    <InputText className="form-control px-3" {...field} keyfilter="email" maxLength="40" />
                                    <ErrorMessage name="email_id" component="span" className="from-error-span" />
                                  </>
                                )} />
                              </div>
                              <div className="col-sm-6 mb-4">
                                <label htmlFor="" className="mb-2">Phone  <span className="text-danger">*</span></label>
                                <Field name="phone" render={({ field }) => (
                                  <>
                                    <InputText {...field} className="form-control px-3" keyfilter="int" maxLength="10" />
                                    <ErrorMessage name="phone" component="span" className="from-error-span" />
                                  </>
                                )} />
                              </div>
                              <div className="col-sm-6 mb-4">
                                <label htmlFor="" className="mb-2">Mobile  <span className="text-danger">*</span></label>
                                <Field name="mobile" render={({ field }) => (
                                  <>
                                    <InputText {...field} className="form-control px-3" keyfilter="int" maxLength="10" />
                                    <ErrorMessage name="mobile" component="span" className="from-error-span" />
                                  </>
                                )} />
                              </div>
                              <div className="col-12 mt-4 mb-3">
                                <h4 className=" fw600 fz16 text-dark"> Billing Address Details </h4>
                                <div className="overflow-auto mt-3 ">
                                  <table className="table  multiple-feilds-table" style={{ minWidth: "1200px" }}>
                                    <thead>
                                      <tr>
                                        <th className="fw500 fz14" width="30px">
                                          #
                                        </th>
                                        <th className="fw500 fz14" width="200px">
                                          Customer Name
                                        </th>
                                        <th className="fw500 fz14">Address  </th>
                                        <th className="fw500 fz14" width="150px">
                                          Suburb
                                        </th>
                                        <th className="fw500 fz14" width="150px">
                                          Zip Code
                                        </th>
                                        <th className="fw500 fz14" width="180px">
                                          Country
                                        </th>
                                        <th className="fw500 fz14" width="150px">
                                          State
                                        </th>
                                        <th className="fw500 fz14" width="30px"></th>
                                      </tr>
                                    </thead>
                                    <tbody>

                                      <FieldArray name="customer_billing_address_details" render={({ push, remove }) => (
                                        values?.customer_billing_address_details && values.customer_billing_address_details.map((val, idx) => (
                                          <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>
                                              <Field name={`customer_billing_address_details[${idx}].customer_name`} render={({ field }) => (
                                                <>
                                                  <InputText className="form-control px-3" {...field} />
                                                  <ErrorMessage name={`customer_billing_address_details[${idx}].customer_name`} component="span" className="from-error-span" />
                                                </>
                                              )} />

                                            </td>
                                            <td>
                                              <Field name={`customer_billing_address_details[${idx}].address`} render={({ field }) => (
                                                <>
                                                  <InputText className="form-control px-3" {...field} />
                                                  <ErrorMessage name={`customer_billing_address_details[${idx}].address`} component="span" className="from-error-span" />
                                                </>
                                              )} />

                                            </td>
                                            <td>
                                              <Field name={`customer_billing_address_details[${idx}].suburb`} render={({ field }) => (
                                                <>
                                                  <InputText className="form-control px-3" {...field} />
                                                  <ErrorMessage name={`customer_billing_address_details[${idx}].suburb`} component="span" className="from-error-span" />
                                                </>
                                              )} />

                                            </td>
                                            <td>
                                              <Field name={`customer_billing_address_details[${idx}].zip_code`} render={({ field }) => (
                                                <>
                                                  <InputText className="form-control px-3" {...field} keyfilter="int" maxLength="4" />
                                                  <ErrorMessage name={`customer_billing_address_details[${idx}].zip_code`} component="span" className="from-error-span" />
                                                </>
                                              )} />

                                            </td>
                                            <td>
                                              <Field name={`customer_billing_address_details[${idx}].country_id`} render={({ field }) => (
                                                <>
                                                  <Select className="w-100 px-3"  {...field} options={getCountryOption()} value={val.country_id} placeholder="Please select a country" />
                                                  <ErrorMessage name={`customer_billing_address_details[${idx}].country_id`} component="span" className="from-error-span" />
                                                </>
                                              )} />

                                            </td>

                                            <td>
                                              <Field name={`customer_billing_address_details[${idx}].state_id`} render={({ field }) => (
                                                <>
                                                  <Select className="w-100 px-3"  {...field} options={getStateOption(val.country_id)} value={val.state_id} placeholder="Please select a state" />
                                                  <ErrorMessage name={`customer_billing_address_details[${idx}].state_id`} component="span" className="from-error-span" />
                                                </>
                                              )} />

                                            </td>


                                            <td>
                                              {values.customer_billing_address_details.length - 1 === idx ? (
                                                <>
                                                  <div className="d-flex gap-2">
                                                    {values.customer_billing_address_details.length > 1 &&
                                                      <button type="button" className="btn fw500 fz14 ms-auto text-danger shadow-none px-0" onClick={() => {
                                                        remove(idx)
                                                        removeCompanyBilling(val?.customer_billing_id)
                                                      }}>
                                                        <i className="fa-regular fa-minus-circle "></i>
                                                      </button>}
                                                    <button type="button" className="btn fw500 fz14 ms-auto text-success shadow-none px-0"
                                                      onClick={() => push(customerInitialState.customer_billing_address_details[0])} >
                                                      <i className="fa-regular fa-plus-circle "></i>
                                                    </button>

                                                  </div>
                                                </>
                                              ) : (
                                                <button type="button" className="btn fw500 fz14 ms-auto text-danger shadow-none px-0" onClick={() => {
                                                  remove(idx)
                                                  removeCompanyBilling(val?.customer_billing_id)
                                                }}>
                                                  <i className="fa-regular fa-minus-circle "></i>
                                                </button>
                                              )}
                                            </td>
                                          </tr>
                                        )
                                        ))} />

                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <div className="col-12 mt-4 mb-3">
                                <h4 className=" fw600 fz16 text-dark"> Documents</h4>
                                <div className="overflow-auto mt-3 ">
                                  <table className="table  multiple-feilds-table">
                                    <thead>
                                      <tr>
                                        <th className="fw500 fz14" width="30px">
                                          #
                                        </th>
                                       
                                        <th className="fw500 fz14 text-end" colSpan={2}>
                                          <button type="button" className="btn btn-primary" data-toggle="modal" onClick={() => openModal()}>
                                            New Document
                                          </button>
                                        </th>
                                      </tr>


                                    </thead>
                                    <tbody>
                                      {/*  <FieldArray name="customer_document_details" render={({ push, remove }) => (
 
                                        ((values?.customer_document_details && values.customer_document_details.length) > 0 ? values?.customer_document_details : customerInitialState.customer_document_details).map((val, idx) => {
                                          return (
                                            <>
                                              <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>
                                                  <Field name={`customer_document_details[${idx}].driver_doc`} render={({ field }) => (
                                                    <>
                                                      <InputText type="file" className="form-control px-3" onChange={(e) => { handleOnChange(e, idx); setFieldValue(`customer_document_details[${idx}].driver_doc`, e.target.files[0].name) }} />
 

                                                      {loadImage(val)}

                                                      <ErrorMessage name={`customer_document_details[${idx}].driver_doc`} component="span" className="from-error-span" />
                                                    </>
                                                  )} />
                                                </td>
                                                <td>
                                                  {values.customer_document_details.length - 1 === idx ? (
                                                    <>
                                                      <div className="d-flex gap-2">
                                                        {values.customer_document_details.length > 1 &&
                                                          <button type="button" className="btn fw500 fz14 ms-auto text-danger shadow-none px-0" onClick={() => {
                                                            remove(idx)
                                                            removeCompanyDocument(val?.customer_document_id)
                                                          }}>
                                                            <i className="fa-regular fa-minus-circle "></i>
                                                          </button>}

                                                        <button type="button" className="btn fw500 fz14 ms-auto text-success shadow-none px-0"
                                                          onClick={() => push(customerInitialState.customer_document_details[0])} >
                                                          <i className="fa-regular fa-plus-circle "></i>
                                                        </button>
                                                      </div>

                                                    </>
                                                  ) : (
                                                    <button type="button" className="btn fw500 fz14 ms-auto text-danger shadow-none px-0" onClick={() => {
                                                      remove(idx)
                                                      removeCompanyDocument(val?.customer_document_id)
                                                    }}>
                                                      <i className="fa-regular fa-minus-circle "></i>
                                                    </button>
                                                  )}
                                                </td>
                                              </tr>
                                              <input type="hidden" name={`customer_document_name`} defaultValue={0} />
                                              <input type="hidden" name={`customer_document_id`} defaultValue={val?.customer_document_id} />
                                            </>
                                          );
                                        })
                                      )} /> */}

                                      <FieldArray name="customer_document_details" render={({ push, remove }) => (

                                        ((values?.customer_document_details && values.customer_document_details.length) > 0 ? values?.customer_document_details : customerInitialState.customer_document_details).map((val, idx) => {
                                          return (
                                            <>
                                              <tr key={idx}>
                                                <td>{val.customer_document_id && idx + 1}</td>
                                                <td>
                                                  <Field name={`customer_document_details[${idx}].driver_doc`} render={({ field }) => (
                                                    <>
                                                      {/* {loadImage(val)} */}

                                                      { val?.document_name !== '' && (((val?.document_name?.split('.')?.pop() === 'pdf')) ? <a href={`${BASE_BACKEND_URL}${val?.document_name}`} target="_blank">View <i className="fa fa-file-pdf-o" aria-hidden="true"></i></a> : <a href={`${BASE_BACKEND_URL}${val?.document_name}`} target="_blank"> <img src={`${BASE_BACKEND_URL}${val?.document_name}`} width="100" /></a>)}
                                                    </>
                                                  )} />
                                                </td>
                                                <td className="fw500 fz14 text-end">
                                                  {val.customer_document_id && <input type="button" className="btn btn-danger" value="X" onClick={(e) => removeImage(val.customer_document_id)} />}
                                                </td>
                                              </tr>
                                            </>
                                          );
                                        })
                                      )} />
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <div className="col-12 mt-4 mb-3">
                                <h4 className=" fw600 fz16 text-dark"> Multiple Notes</h4>
                                <div className="overflow-auto mt-3 ">
                                  <table className="table  multiple-feilds-table">
                                    <thead>
                                      <tr>
                                        <th className="fw500 fz14" width="30px">
                                          #
                                        </th>
                                        <th className="fw500 fz14">Notes  </th>
                                        <th className="fw500 fz14" width="30px"></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <FieldArray name="customer_notes_details" render={({ push, remove }) => (
                                        values?.customer_notes_details && values?.customer_notes_details.map((val, idx) => (
                                          <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>

                                              <Field name={`customer_notes_details[${idx}].notes_content`} render={({ field }) => (
                                                <>
                                                  <InputTextarea className="form-control px-3"  {...field} />
                                                  <ErrorMessage name={`customer_notes_details[${idx}].notes_content`} component="span" className="from-error-span" />
                                                </>
                                              )} />
                                            </td>

                                            <td>
                                              {values?.customer_notes_details.length - 1 === idx ? (
                                                <>
                                                  <button type="button" className="btn fw500 fz14 ms-auto text-success shadow-none px-0" onClick={() => push(customerInitialState.customer_notes_details[0])} >
                                                    <i className="fa-regular fa-plus-circle "></i>
                                                  </button>
                                                  {values?.customer_notes_details.length > 1 &&
                                                    <button type="button" className="btn fw500 fz14 ms-auto text-danger shadow-none px-0"
                                                      onClick={() => {
                                                        remove(idx)
                                                        removeCompanyNote(val?.notes_id)
                                                      }}>
                                                      <i className="fa-regular fa-minus-circle "></i>
                                                    </button>}
                                                </>
                                              ) : (
                                                <button type="button" className="btn fw500 fz14 ms-auto text-danger shadow-none px-0"
                                                  onClick={() => {
                                                    remove(idx)
                                                    removeCompanyNote(val?.notes_id)
                                                  }}>
                                                  <i className="fa-regular fa-minus-circle "></i>
                                                </button>
                                              )}
                                            </td>
                                          </tr>
                                        )
                                        )
                                      )} />
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          )
        }
      </Formik>

      {/* Modal   */}

      <Modal show={modalShow} onHide={() => setModalShow(false)} size="lg" centered>
        <Modal.Header closeButton={false}>
          <Modal.Title> Add Customer Document </Modal.Title>
          <Button className="btn-close ms-2 " onClick={() => setModalShow(false)} variant=""></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="px-0 table-wrapper">

            <div className="row">
              <div className="col-md-6 offset-3">
                <form>
                  <div className="form-group">
                    <label htmlFor="recipient-name" className="col-form-label">Upload  (jpg,png,jpeg,pdf 6 MB Only) </label>
                    <input type="file" className="form-control" name="document_name" onChange={(e) => uploadImageHandler(e)} />
                  </div>


                  <div className="form-group">
                    <div className="text-center btn-block p-3">
                      <input type="submit" name="submit" className="btn btn-primary" value="Save" onClick={(e) => saveFile(e)} />
                    </div>
                  </div>

                </form>
              </div>
            </div>


          </div>
        </Modal.Body>
      </Modal>




    </>
  );
}

export default Edit;
